import { cx, styled } from "simplydo/react/styled";

import { Slot } from "../utils/Slot";
import type { ListDescriptionProps } from "./List.types";

const DescriptionEl = styled.div`
  color: rgba(0, 0, 0, 0.6);
`;

const ListDescriptionComponent = (props: ListDescriptionProps) => {
  const { asChild, children, className, style, ...rest } = props;
  return (
    <DescriptionEl
      as={asChild ? Slot : undefined}
      className={cx(className)}
      style={style}
      {...rest}
    >
      {children}
    </DescriptionEl>
  );
};

export const ListDescription = styled(ListDescriptionComponent)``;
